import { BaseModel } from "sjs-base-model";
import CercaPreventiviTabellaModel from "./CercaPreventiviTabellaModel";

export default class CercaPreventiviModel extends BaseModel {
    public readonly data: CercaPreventiviTabellaModel[] = [];
    public readonly pageNumber: number = 0;
    public readonly pageSize: number = 0;
    public readonly totalPages: number = 0;
    public readonly totalRecords: number = 0;

    constructor(data: Partial<CercaPreventiviModel>) {
        super();

        this.update(data);
    }
}
